import React, {useState} from 'react';
import AppRoutes from "./Routes"
import { FormDataProvider } from "./Hooks/useFormDataContext";

export default function App() {
  return (  
    <FormDataProvider>
      <AppRoutes />
    </FormDataProvider>
  )
}


